import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import axios from "axios";
import '../../Style/EditModal.scss';
import "../../Style/TableStyle.scss"
import '../../Style/__searchbar.scss'
import '../../Style/__button.scss'
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
// import { AiOutlineFilePdf } from "react-icons/ai";
import { SiHyperledger } from "react-icons/si";
// import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { Month } from '../../OtherData/Month'
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
// import jwtDecode from "jwt-decode";
import { TaxWagesReportHeader } from "./GridHeaders/TaxWagesReportHeader";
import DataGridComponent from "../../Components/DataGridComponent";
import { errorAlert } from "../../Components/Alerts";
import { ElementsParagraph, TitleElements } from "../../Components/HeadersCRUD-s";
import { AddActionsButton } from "../../Components/AddElementsButton";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { WagesReportExcel } from "../../Print/WagesReportExcel";
import { AiOutlineFileExcel } from "react-icons/ai";
import TotalSummaryComponent from "../../Components/TotalSummaryComponent";


export default function TaxWagesReport() {
    const [data, setData] = useState([]);
    const headers = authHeader();
    const { fiscalYear } = useContext(FiscalYearContext);

    const [month, setMonth] = useState(0);

    const fetchData = async (month, fiscalY) => {
        try {
            const response = await axios.get(ApiLink.API_URL + 'TaxReport/TaxWagesReport', { headers, params: { month: month, fiscalyear: fiscalY } });
            setData(response.data);
        } catch (error) {
            errorAlert("Gabim në kërkesë:", error);
            if (error.response && error.response.data && error.response.data.errorMessage) {
                errorAlert(`Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`);
            } else if (error.message) {
                errorAlert(`Gabim: ${error.message} `);
            } else {
                errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
            }
        }
    };

    const handleDownloadExcel = () => {
        const workbook = WagesReportExcel(data);
        workbook.xlsx.writeBuffer().then(buffer => {
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = URL.createObjectURL(blob);

            // Krijo një element për shkarkim
            const a = document.createElement('a');
            a.href = url;

            // (month === 0 ?
            //     a.download = `LSH_Periudha nga_${formatDate(ngaData)}_Deri_${formatDate(deriData)}.xlsx` :
            //     a.download = `LSH_${month}_${fiscalYear}.xlsx`
            // )
            a.download = `WM_CM_${month}_${fiscalYear}.xlsx`

            a.click();
            URL.revokeObjectURL(url);
        });
    };

    const pagaNeto = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.PagaNeto), 0);
    }, [data]);

    const kontributet = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.KontributiPunedhenesit) + Number(item.KontributiPunetorit), 0);
    }, [data]);

    const pagaBruto = useMemo(() => {
        return data.reduce((sum, item) => sum + Number(item.PagaBruto), 0);
    }, [data]);

    const rows = data.map((item, index) => ({
        id: ++index,
        emri: item.Emri,
        mbiemri: item.Mbiemri,
        numripersonal: item.NumriPersonal,
        // total: item.Total,
        pagabruto: item.PagaBruto,
        kontributipunedhenesit: item.KontributiPunedhenesit,
        kontributipunetorit: item.KontributiPunetorit,
        kontributisuplementarpunesuarit: 0,
        kontributisuplementarpunedhenesit: 0,
        puneprimare: item.PunePrimare,
        perfshihenkontributet: item.PerfshihenKontributet,
        aplikohettatiminepaga: item.AplikohetTatimiNePaga,
    }));


    useEffect(() => {
        fetchData(month, fiscalYear);
    }, [month, fiscalYear]);

    return (
        <div className="AccountingBooks__Container">
            <TitleElements
                icon={SiHyperledger}
                title="Raporti mujor i pagave për ATK"
            />
            <ElementsParagraph text="Ky format i raportit të pagave është është i përshtatur për ngarkim në sistemin e ATK-së." />
            <div className="AccountingBooks__Container__Body">
                <div className="AccountingBooks__Container__SearchSection">
                    <AddActionsButton
                        text="XLSX"
                        onClick={handleDownloadExcel}
                        icon={<AiOutlineFileExcel />}
                        className="button-15"
                    />
                    <div className="AccountingBooks__Container__SearchSection__Search">
                        <div className="AccountingBooks__Container__SearchSection__Search__Input">
                            <TextField
                                className="AccountingBooks__Container__SearchSection__Search__Input__Month"
                                // style={{ width: "200px", marginLeft: "5px" }}
                                id=""
                                select
                                label="Përzgjedh muajin"
                                value={month}
                                onChange={event => {
                                    setMonth(event.target.value);
                                    fetchData(event.target.value, fiscalYear); // Thirrja e fetchData pasi të përditësohet vlera e muajit
                                }}
                                required
                            >
                                {Month.map((data) => (
                                    <MenuItem key={data.id} value={data.id}>
                                        {fiscalYear}{data.month}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </div>
                    </div>
                </div>
            </div>
            <hr></hr>
            <DataGridComponent columns={TaxWagesReportHeader} rows={rows} />
            <TotalSummaryComponent
                fields={[
                    { id: '1', label: 'Pagat Bruto', value: pagaBruto },
                    { id: '2', label: 'Kontributet', value: kontributet },
                    { id: '3', label: 'Pagat Neto', value: pagaNeto },
                ]}
            />
        </div>
    )
}